import { Inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(@Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService) {
    super();
    this.getAndInitTranslations();
    this.i18NextService.events.languageChanged.subscribe(() => {
      this.getAndInitTranslations();
    });
  }

  private getAndInitTranslations(): void {
    this.firstPageLabel = `${this.i18NextService.t('PAGINATOR.FIRSTPAGE')}`;
    this.lastPageLabel = `${this.i18NextService.t('PAGINATOR.LASTPAGE')}`;
    this.nextPageLabel = `${this.i18NextService.t('PAGINATOR.NEXTPAGE')}`;
    this.previousPageLabel = `${this.i18NextService.t('PAGINATOR.PREVIOUSPAGE')}`;
    this.itemsPerPageLabel = `${this.i18NextService.t('PAGINATOR.ITEMS_PER_PAGE')}`;
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.i18NextService.t('PAGINATOR.RESULTS')}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.i18NextService.t('PAGINATOR.SEPARATOR')} ${length}`;
  };
}
